"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RBUXScopePermission = exports.RBAC_SYNTHETICS_TEST_READ = exports.RBAC_SYNTHETICS_AGENT_READ = exports.RBAC_SAVED_VIEWS_READ = exports.RBACSavedViewPermission = exports.RBACDevicePermission = exports.RBACDashboardPermission = exports.RBACBoardPermission = exports.NECESSARY_RBAC_ROLES_FOR_SUBSCRIPTIONS = void 0;
const RBAC_SAVED_VIEWS_READ = exports.RBAC_SAVED_VIEWS_READ = 'saved_views::read';
const RBAC_SYNTHETICS_TEST_READ = exports.RBAC_SYNTHETICS_TEST_READ = 'synthetics.test::read';
const RBAC_SYNTHETICS_AGENT_READ = exports.RBAC_SYNTHETICS_AGENT_READ = 'synthetics.agent::read';

/** For existing *.js permission check. *ts should use RBACString type */
let RBACDevicePermission = exports.RBACDevicePermission = /*#__PURE__*/function (RBACDevicePermission) {
  RBACDevicePermission["CREATE"] = "device::create";
  RBACDevicePermission["READ"] = "device::read";
  RBACDevicePermission["UPDATE"] = "device::update";
  RBACDevicePermission["DELETE"] = "device::delete";
  return RBACDevicePermission;
}({});
/** For existing *.js permission check. *ts should use RBACString type */
let RBACDashboardPermission = exports.RBACDashboardPermission = /*#__PURE__*/function (RBACDashboardPermission) {
  RBACDashboardPermission["CREATE"] = "dashboards::create";
  RBACDashboardPermission["READ"] = "dashboards::read";
  RBACDashboardPermission["UPDATE"] = "dashboards::update";
  RBACDashboardPermission["DELETE"] = "dashboards::delete";
  return RBACDashboardPermission;
}({});
/** For existing *.js permission check. *ts should use RBACString type */
let RBACBoardPermission = exports.RBACBoardPermission = /*#__PURE__*/function (RBACBoardPermission) {
  RBACBoardPermission["CREATE"] = "board::create";
  RBACBoardPermission["READ"] = "board::read";
  RBACBoardPermission["UPDATE"] = "board::update";
  RBACBoardPermission["DELETE"] = "board::delete";
  return RBACBoardPermission;
}({});
/** For existing *.js permission check. *ts should use RBACString type */
let RBACSavedViewPermission = exports.RBACSavedViewPermission = /*#__PURE__*/function (RBACSavedViewPermission) {
  RBACSavedViewPermission["CREATE"] = "saved_views::create";
  RBACSavedViewPermission["READ"] = "saved_views::read";
  RBACSavedViewPermission["UPDATE"] = "saved_views::update";
  RBACSavedViewPermission["DELETE"] = "saved_views::delete";
  return RBACSavedViewPermission;
}({});
/** For existing *.js permission check. *ts should use RBACString type */
let RBUXScopePermission = exports.RBUXScopePermission = /*#__PURE__*/function (RBUXScopePermission) {
  RBUXScopePermission["CREATE"] = "rbux.scope::create";
  RBUXScopePermission["READ"] = "rbux.scope::read";
  RBUXScopePermission["UPDATE"] = "rbux.scope::update";
  RBUXScopePermission["DELETE"] = "rbux.scope::delete";
  RBUXScopePermission["ASSIGN_TO_USER"] = "rbux.scope.user::assign_to_scope";
  RBUXScopePermission["REMOVE_FROM_USER"] = "rbux.scope.user::remove_from_scope";
  return RBUXScopePermission;
}({});
/**
 * TODO WARNING: Unfortunately you can't add any more roles to this collection as the backend does not support this!
 * TODO You will first need to verify that fetchPermittedLabelItems has been updated to allow for multi-permission fetches.
 * TODO then remove these TODOs so nobody else worries about it :)
 */
const NECESSARY_RBAC_ROLES_FOR_SUBSCRIPTIONS = exports.NECESSARY_RBAC_ROLES_FOR_SUBSCRIPTIONS = ['device::read'];